const ROLE_LABELS: Record<number, string> = {
  1: 'superadmin',
  2: 'admin',
  5: 'advanced',
  3: 'member',
};

const ROLE_RANKS: Record<number, number> = {
  1: 1,
  2: 2,
  5: 3,
  3: 4,
};

export function getRoleLabel(roleId: number): string {
  return ROLE_LABELS[roleId] ?? 'unknown';
}

export function getRoleRank(roleId: number): number {
  return ROLE_RANKS[roleId] ?? Number.MAX_SAFE_INTEGER;
}

export function isRoleAtOrAbove(roleId: number, compareRoleId: number): boolean {
  return getRoleRank(roleId) <= getRoleRank(compareRoleId);
}

export function canManageRole(currentRoleId: number, targetRoleId: number): boolean {
  return getRoleRank(targetRoleId) >= getRoleRank(currentRoleId);
}
